<div class="page-wrapper p-3 fd-pop">
  <div class="container p0">
    <div class="row">
      <div class="form-group col">
        <div class="mb-2 text-center">
          <h1>{{ headerText }}</h1>
          <!-- <h1>Please confirm your e-mail ID</h1> -->
        </div>
      </div>
      <!-- <div class="col-md-2 mb-4 mt-4">Mail me</div> -->
      <div class="col-md-12">
        <form #myForm="ngForm" (ngSubmit)="submit(myForm)">
          <input
            class="form-control block text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            id="exampleInputEmail1"
            placeholder="Please enter your e-mail ID"
            [(ngModel)]="mail"
            name="email"
            #email="ngModel"
            pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
            required
            (keypress)="handleEmail($event)"
            (pointerdown)="handleEmail($event)"
            (keyup)="handleEmail($event)"
          />
          <div *ngIf="error" class="text-danger mt-1 error">
            {{ error }}
          </div>

          <div class="dis-note mt-2">
            Please validate the e-mail address. Sharing this link with anyone else will provide them access to your unique report and data.
            <!-- Please validate e-mail carefully before mailing your report.<br>
            Sharing this link provides access to your unique report along with your data. -->

          </div>
          <div class="form-group row pt-3 text-center" *ngIf="btnSection=='mailMe'">
            <div class="col btn-section text-center mt-2">
              <a class="page-close-btn mx-1" (click)="close()">Close</a>

              <button
                class="page-btn mx-1"
                type="submit"
                [disabled]="!myForm.valid"
                type="submit"
                [ngClass]="!myForm.valid ? 'cursor-not-allowed' : ''"
              >
                Send
              </button>
            </div>
          </div>


          <div class="form-group row pt-3 text-center" *ngIf="btnSection=='saveChanges'" >
            <div class="col btn-section text-center mt-2">
              <a class="page-close-btn mx-1" (click)="exit()">Exit</a>

              <button
                class="page-btn mx-1"
                type="submit"
                [disabled]="!myForm.valid"
                type="submit"
                [ngClass]="!myForm.valid ? 'cursor-not-allowed' : ''"
              >
                Save
              </button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>
